import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const Gallery = () => {
  const [albums, setAlbums] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://njinternational.ilakshyaerp.in/api/gallery/album")
      .then(res => res.json())
      .then(res => setAlbums(Array.isArray(res) ? res : []));
  }, []);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />
      <div className="container">

        <div className="gallery-section">
          <h2 className="gallery-title">GALLERY ALBUM</h2>
        </div>

        <div className="life-gallery-grid">

          {albums.map(a => (
            <div
              key={a.id}
              className="life-gallery-card"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/gallery/${a.id}`);
              }}
            >
              <img
                src={
                  a.coverImage
                    ? `https://njinternational.ilakshyaerp.in/uploads/gallery/${a.coverImage}`
                    : "https://picsum.photos/400/300"
                }
                alt={a.name}
              />

              <div className="life-gallery-overlay">
                <h3>{a.name}</h3>
              </div>
            </div>
          ))}

        </div>

      </div>

      <Footer />
    </>
  );
};

export default Gallery;